export const notificationError = 'error';
export const notificationInfo = 'info';
